import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnHarvey extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return this.generateHarveyBall(row[this.field]);
    }

    public generateHarveyBall(value: number) {
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.style.width = "22px";
        svg.style.height = "22px";
        svg.setAttribute("viewBox", "0 0 22 22");

        switch (value) {
            case 0:
                svg.appendChild(this.circle("#ffffff"));
                break;
            case 1:
            case 25:
                svg.appendChild(this.circle("#ffffff"));
                svg.appendChild(this.path("m 11,11 v -10 a 10,10 0 0 1 10,10 z"));
                break;
            case 2:
            case 50:
                svg.appendChild(this.circle("#ffffff"));
                svg.appendChild(this.path("m 11,11 v -10 a 10,10 0 0 1 0,20 z"));
                break;
            case 3:
            case 75:
                svg.appendChild(this.circle("#ffffff"));
                svg.appendChild(this.path("m 11,11 v -10 a 10,10 0 1 1 -10,10 z"));
                break;
            case 4:
            case 100:
                svg.appendChild(this.circle("#000000"));
                break;
        }
        return (svg as any);
    }

    private circle(fill: string): SVGCircleElement {
        var circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", "11px");
        circle.setAttribute("cy", "11px");
        circle.setAttribute("fill", fill);
        circle.setAttribute("stroke", "#000000");
        circle.setAttribute("stroke-width", "1");
        circle.setAttribute("r", "10px");
        return circle;
    }

    private path(d: string): SVGPathElement {
        var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", d);
        path.setAttribute("style", "fill: rgb(0, 0, 0)");
        return path;
    }
}